import { apiClient, ApiResponse } from '../utils/api';
import UrlBuilder from '../utils/urls';

export type SupportContactResponse = {
  status: string;
  message: string;
};

export async function sendSupportMessage(params: {
  email: string;
  message: string;
  name?: string;
  token?: string | null;
}): Promise<ApiResponse<SupportContactResponse>> {
  const body = {
    email: params.email,
    message: params.message,
    name: params.name || '',
    source: 'app',
    website: '',
  };

  const url = UrlBuilder.support.contact();

  if (params.token) {
    return apiClient.postWithToken<SupportContactResponse>(url, params.token, body);
  }

  return apiClient.post<SupportContactResponse>(url, body);
}
